/* =================== Debug switches =================== */
const DEBUG_OMETRIA = false;

/* =================== Utilities =================== */
function maskEmail(s) {
  if (!s) return s;

  const parts = String(s).split("@");
  const user = parts[0];
  const dom = parts[1];

  if (!dom) return "***";

  const u =
    user.length <= 2
      ? user[0] + "*"
      : user[0] +
        "*".repeat(Math.max(1, user.length - 2)) +
        user.slice(-1);

  return u + "@" + dom;
}

function dbg() {
  if (
    DEBUG_OMETRIA &&
    typeof console !== "undefined" &&
    console.log
  ) {
    console.log.apply(console, arguments);
  }
}

function grp(title, collapsed) {
  if (!DEBUG_OMETRIA || typeof console === "undefined") {
    return function () {};
  }

  const fn =
    collapsed && console.groupCollapsed
      ? "groupCollapsed"
      : console.group
        ? "group"
        : null;

  if (fn) console[fn]("[zy] " + title);

  return function () {
    if (console.groupEnd) console.groupEnd();
  };
}

/* =================== Ometria lookup =================== */
async function ometriaLookup(body) {
  dbg("[zy] lookup → email:", maskEmail(body.email));

  var r = await fetch(
    "https://zls-prod-ne-01-apim.zippylosan.com/ometria/checkuserexists",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "zls-key": "fb97930859c84cdb95c6354b2487ce40",
        "User-Agent": "shopify-script"
      },
      body: JSON.stringify(body)
    }
  );

  dbg("[zy] lookup ← status:", r.status, r.statusText);

  var json = null;

  try {
    json = await r.json();
  } catch (e) {
    dbg("[zy] lookup ← JSON parse error:", e);
    throw e;
  }

  dbg("[zy] lookup ← subscription:", {
    exists: json && json.exists,
    signup_source: json && json.signup_source
  });

  if (!r.ok) throw new Error("Lookup falhou");

  return json;
}

/* =================== Submit handler =================== */
window.zyProcessSubmit = async function (event) {
  var endGroup = grp("submit", true);

  try {
    event.preventDefault();

    var form = event.target;

    var currentLocale =
      typeof window !== "undefined" && window.formLocale
        ? window.formLocale
        : "en";

    // Native validity first.
    if (!form.checkValidity()) {
      dbg("[zy] native validity failed");
      form.reportValidity();
      endGroup();
      return false;
    }

    var submitBtn = form.querySelector('input[type="submit"]');
    var msgDiv = form.querySelector("#ometria-message");

    var messages = {
      "pt-PT": {
        validating: "A validar...",
        emailExists: "Este e-mail já está subscrito.",
        error: "Erro no processamento. Tente novamente mais tarde."
      },
      en: {
        validating: "Validating...",
        emailExists: "This email is already subscribed.",
        error: "Processing error. Please try again later."
      }
    };

    var msg = messages[currentLocale] || messages.en;

    // Clear previous messages.
    msgDiv.textContent = "";
    msgDiv.className = "";

    // Get email.
    var emailEl = form.querySelector("#subscriberemail");
    var email = emailEl
      ? emailEl.value.trim().toLowerCase()
      : "";

    dbg("[zy] inputs", {
      locale: currentLocale,
      email: maskEmail(email)
    });

    // Update submit button.
    var originalBtnText = submitBtn ? submitBtn.value : "";

    if (submitBtn) {
      submitBtn.value = msg.validating;
      submitBtn.disabled = true;
    }

    try {
      // Perform lookup by email only.
      dbg("[zy] performing email lookup…");

      var emailData = await ometriaLookup({ email: email });

      // Duplicate newsletter check.
      var emailExists =
        String(emailData && emailData.exists).toLowerCase() === "true";

      var sourceRaw =
        emailData && emailData.signup_source
          ? emailData.signup_source
          : "";

      var source = String(sourceRaw).toLowerCase();
      var isNewsletterSource = /newsletter/.test(source);

      dbg("[zy] newsletter duplicate check", {
        emailExists: emailExists,
        signup_source: sourceRaw,
        isNewsletterSource: isNewsletterSource
      });

      // Block any existing email, regardless of signup source.
if (emailExists) {
  msgDiv.textContent = msg.emailExists;
  msgDiv.className = "ometria-message error";

  if (submitBtn) {
    submitBtn.value = originalBtnText;
    submitBtn.disabled = false;
  }

  dbg("[zy] blocked: email already exists");

  endGroup();
  return false;
}
      // Submit to Ometria.
      form.action = "https://api.ometria.com/forms/signup";
      form.onsubmit = null;

      dbg("[zy] submitting form to Ometria…");

      HTMLFormElement.prototype.submit.call(form);

      endGroup();
      return true;
    } catch (err) {
      console.error("[zy] Ometria error", err);

      msgDiv.textContent = msg.error;
      msgDiv.className = "ometria-message error";

      if (submitBtn) {
        submitBtn.value = originalBtnText;
        submitBtn.disabled = false;
      }

      endGroup();
      return false;
    }
  } catch (outerErr) {
    console.error("[zy] submit outer error", outerErr);
    endGroup();
    return false;
  }
};

/* =================== Real-time validation =================== */
function zyInitNewsletterForm() {
  var form = document.querySelector("#formsubs form");

  if (!form || form.dataset.zyInitialized === "true") return;

  form.dataset.zyInitialized = "true";

  var errorMessages = {
    "pt-PT": {
      subscribername: "Por favor, insira o seu nome.",
      subscriberemail: "Por favor, insira o seu e-mail.",
      subscriberconditions:
        "Por favor, aceite as condições para continuar.",
      defaultRequired: "Campo obrigatório.",
      invalidEmail: "Por favor, insira um endereço de e-mail válido."
    },
    en: {
      subscribername: "Please enter your name.",
      subscriberemail: "Please enter your email.",
      subscriberconditions: "Please accept the conditions to continue.",
      defaultRequired: "This field is required.",
      invalidEmail: "Please enter a valid email address."
    }
  };

  function isValidEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }

  function clearFieldError(field) {
    field.classList.remove("error");
    field.removeAttribute("aria-invalid");

    var parent = field.closest(".option");

    if (parent) {
      parent.querySelectorAll(".error-message").forEach(function (error) {
        error.remove();
      });
    }
  }

  function validateField(field) {
    if (!field) return true;

    clearFieldError(field);

    var value = field.value.trim();
    var isCheckbox = field.type === "checkbox";
    var isEmail = field.type === "email";
    var parent = field.closest(".option");
    var errorMessageText = "";

    var currentLocale =
      typeof window !== "undefined" && window.formLocale
        ? window.formLocale
        : "en";

    var messages =
      errorMessages[currentLocale] || errorMessages.en;

    if (field.hasAttribute("required")) {
      if (
        (isCheckbox && !field.checked) ||
        (!isCheckbox && value === "")
      ) {
        errorMessageText =
          messages[field.id] || messages.defaultRequired;
      } else if (
        isEmail &&
        value !== "" &&
        !isValidEmail(value)
      ) {
        errorMessageText = messages.invalidEmail;
      }
    }

    if (!errorMessageText) return true;

    field.classList.add("error");
    field.setAttribute("aria-invalid", "true");

    if (parent) {
      var error = document.createElement("span");

      error.className = "error-message";
      error.textContent = errorMessageText;

      parent.appendChild(error);
    }

    return false;
  }

  var fields = form.querySelectorAll(
    "#subscribername, #subscriberemail, #subscriberconditions"
  );

  fields.forEach(function (field) {
    var isCheckbox = field.type === "checkbox";

    field.addEventListener(
      isCheckbox ? "change" : "input",
      function () {
        clearFieldError(field);
      }
    );

    field.addEventListener(
      isCheckbox ? "change" : "blur",
      function () {
        if (field.hasAttribute("required")) {
          validateField(field);
        }
      }
    );
  });

  // Use one submit listener, without an inline handler.
  form.removeAttribute("onsubmit");
  form.onsubmit = null;
  form.addEventListener("submit", window.zyProcessSubmit);
}

/* =================== Initialization =================== */
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", zyInitNewsletterForm);
} else {
  zyInitNewsletterForm();
}